<template>
    <footer :style="footerStyles">
        <div class="disclaimer">
            <p class="first-section"></p>
            <p class="first-section"></p>
        </div>
    </footer>
</template>

<script>
export default {
    name: "custom-form-create-footer-component",
    props: {
        bgColor: {
            type: String,
            required: false,
            default: '#06a1ff'
        },
        titleColor: {
            type: String,
            required: false,
            default: '#fff'
        }
    },
    computed: {
        footerStyles() {
            return {
                'background-color': this.bgColor,
                'color': this.titleColor,
            }
        },
    }
}
</script>

<style scoped lang="scss">
    footer {
       padding: map-get($grid-gutter-spacing, 'twenty-one');
        font-size: 0.75rem;
        letter-spacing: 0.1px;

        a {
            color: $white;
            font-weight: $font-weight-bold;
        }
    }
</style>
